 import { Dialog, DialogContent } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { X, Check } from "lucide-react";

export function ResponsiveDialogContent({
  title,
  open,
  onOpenChange,
  children,
  onSubmit,
  saving,
  submitLabel,
}: {
  title: string;
  open: boolean;
  onOpenChange: (v: boolean) => void;
  children: React.ReactNode;
  onSubmit: () => void;
  saving?: boolean;
  submitLabel: string;
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        onOpenAutoFocus={(e) => e.preventDefault()} // ✅ avoids focus glitches on mobile
        className="
          p-0 overflow-hidden
          w-[calc(100vw-1rem)] sm:max-w-[640px]
          max-h-[92vh] sm:max-h-[85vh]
          rounded-2xl
        "
      >
        {/* Header */}
        <div className="sticky top-0 z-20 border-b border-border bg-background/95 backdrop-blur px-4 py-3 flex items-center justify-between">
          <div className="min-w-0">
            <div className="text-base font-semibold truncate">{title}</div>
            <div className="text-xs text-muted-foreground">Fill details then save</div>
          </div>

          <Button
            type="button"
            variant="ghost"
            className="h-9 w-9 rounded-xl"
            onClick={() => onOpenChange(false)}
            aria-label="Close"
          >
            <X className="h-4 w-4" />
          </Button>
        </div>

        {/* Scroll body */}
        <div className="px-4 py-4 overflow-y-auto max-h-[calc(92vh-3.25rem-4rem)] sm:max-h-[calc(85vh-3.25rem-4rem)]">
          {children}
        </div>

        {/* Sticky footer */}
        <div className="sticky bottom-0 z-20 border-t border-border bg-background/95 backdrop-blur px-4 py-3">
          <div className="flex gap-2">
            <Button
              type="button"
              variant="outline"
              className="flex-1 rounded-xl"
              onClick={() => onOpenChange(false)}
              disabled={!!saving}
            >
              Cancel
            </Button>

            <Button
              type="button"
              className="flex-1 rounded-xl bg-emerald-600 hover:bg-emerald-700 text-white"
              onClick={onSubmit}
              disabled={!!saving}
            >
              {saving ? "Saving..." : (
                <>
                  <Check className="h-4 w-4 mr-2" />
                  {submitLabel}
                </>
              )}
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}